export const OKX_XBTC_INVESTMENT_ID = 25019;

export const OKX_USDC_INVESTMENT_ID = 33336;

export const OKX_APT_INVESTMENT_ID = 40049;
